import { Record } from 'immutable';
import { LookupAddress } from '../../event/models/lookup-address';

const PropertyLookupSummaryRecord = Record({
  chain: null,
  brand: null,
  propertyId: null,
  name: null,
  address: new LookupAddress({}),
  manuallyAdded: null,
  subscriber: false
});

export class PropertyLookupSummary extends PropertyLookupSummaryRecord {
  chain: string;
  brand: string;
  propertyId: string;
  name: string;
  address: LookupAddress;
  manuallyAdded: boolean;
  subscriber: boolean;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/models/property-lookup-summary.ts